import { Icon } from './_Icon';
export const SearchIcon = (props) => (
  <Icon {...props} d="M18 11a7 7 0 1 1-14 0 7 7 0 0 1 14 0z M21 21l-4.35-4.35" />
);
